import { sortBy, identity } from 'lodash';
import moment from 'moment';
import React, { useMemo, useEffect } from 'react';
import { DEFAULT_INCLUSIVITY } from '../../../../../data/constants/datetime';
import meetingState from '../../../../../data/constants/meetingState';
import { isCurrentMeeting, isUpcomingMeeting } from '../../../../../data/filters/meetingFilters';
import { isCurrentSession } from '../../../../../data/filters/schedule/isCurrentSession';
import { isUpcomingSession } from '../../../../../data/filters/scheduleFilters';
import { useTimeFormatter, useUpdateWhenScheduleAdvances } from '../../../../../data/hooks/datetimeHooks';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useMeetings } from '../../../../../data/hooks/meeting/useMeetings';
import { useScheduleEnabled } from '../../../../../data/hooks/schedule/useScheduleEnabled';
import { useUserPotentialSchedule } from '../../../../../data/hooks/schedule/useUserPotentialSchedule';
import { useEventSchedule } from '../../../../../data/hooks/schedule/useEventSchedule';
import EventTimezone from '../../../../elements/EventTimezone/EventTimezone';
import SectionLinkedHeader from '../../../../elements/SectionHeader/SectionLinkedHeader/SectionLinkedHeader';
import styles from './EventProgramSection.module.scss';
import NextItem from './innerElements/NextItem';

const HIDE_ROUNDS_AFTER_N_MINUTES = 10;

function displayableSessions(s) {
    return (
        isUpcomingSession(s) ||
        (isCurrentSession(s) && (s.display_type != 'round' || moment().isBetween(s.start_local, moment(s.start_local).add(HIDE_ROUNDS_AFTER_N_MINUTES, 'minutes'), null, DEFAULT_INCLUSIVITY)))
    );
}

function displayableMeetings(meeting) {
    return [meetingState.CONFIRMED, meetingState.PENDING].includes(meeting._state) && (isCurrentMeeting(meeting) || isUpcomingMeeting(meeting));
}

const EventProgramSection = (props) => {
    const { event } = props,
        url = ['/events', event.id, 'schedule'].join('/'),
        i18n = useI18n(),
        scheduleEnabled = useScheduleEnabled(event.id),
        schedule = useEventSchedule(event.id),
        nextSessions = useUserPotentialSchedule(event.id).filter(displayableSessions).slice(0, 2),
        nextMeetings = useMeetings(event.id, {
            count: 2,
            filter: displayableMeetings,
        }),
        next = useMemo(() => {
            return sortBy([...nextSessions, ...nextMeetings], ['start_utc']).slice(0, 2);
        }, [nextMeetings, nextSessions]),
        formatTime = useTimeFormatter();

        useUpdateWhenScheduleAdvances(event.id);

    // Only show stuff if the feature is enabled and there is content
    if (!scheduleEnabled || !schedule.length) return null;

    return (
        <div className={['content', styles.EventProgramSection, 'striped'].join(' ')}>
            <SectionLinkedHeader href={url} color={event.settings.primary_color} next>
                <span className="pull-right capitalize"></span>
                {i18n['label.schedule']}
                <EventTimezone event={event} />
            </SectionLinkedHeader>
            {next.map((item, i) =>
                i == 0 || isCurrentSession(next[i - 1]) ? (
                    <NextItem event={event} item={item} key={`${item.id}-${item.invited}`} previous={next[i - 1]} className={styles.nextItem} formatTime={formatTime} />
                ) : null
            )}
        </div>
    );
};

export default EventProgramSection;
